import {Injectable}                      from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {Api}                             from '../api.service';
import {Observable}                      from 'rxjs';
import {ContactMomentCollection}         from '../api/bases/proxy/schemas/contactMoments/api.models';

@Injectable()
class ContactMomentsResolver implements Resolve<any> {
    constructor(private api: Api) {}

    resolve(route: ActivatedRouteSnapshot): Observable<ContactMomentCollection> {
        const baseId: number   = route.params[route.data['contactMomentBaseIdentifier']];
        const schemaId: number = route.params[route.data['contactMomentSchemaIdentifier']];

        return this.api.bases().proxy(baseId).schemas().contactMoments(schemaId).collection(1, 100000);
    }
}

export {
    ContactMomentsResolver
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/resolvers/contact-moments.resolver.ts